import React from "react";
import AbroadContent from "./AbroadComponents/AbroadContent";
import "./Abroad.css";

export default function Abroad() {
  return (
    <>
      <AbroadContent />
    </>
  );
}

